import React from "react";
import ContentLoader from "react-content-loader";

const CredentialLoaders = () => {

    return (
        <div>
            <ContentLoader style={{ height: '100%', width:'100%' }} viewBox="0 0 351.1 80">
                <rect x="5" y="16" rx="5" ry="5" width="25" height="25" />
                <rect x="40" y="20" rx="5" ry="5" width="100" height="17" />

                <rect x="205" y="16" rx="5" ry="5" width="25" height="25" />
                <rect x="240" y="20" rx="5" ry="5" width="100" height="17" />
            </ContentLoader>

        </div>
    )
};

export default CredentialLoaders;